import {DEFAULT_PAGE_SIZE} from '../../constants';

export const tableHelpers = {
  getOrderByValue: (sorter = {}) => {
    const {order, field} = sorter;
    return order ? `${order === 'descend' ? '-' : ''}${field}` : undefined
  },
  handleOnPaginate: ({activePage = 1, loadData, setTableData, tableData = {}}) => {
    const { page: currentPage, loadedPages, pagination } = tableData;

    const isForwardPagination = activePage > currentPage;
    const isPageNotLoaded = loadedPages < activePage;

    if (isForwardPagination && isPageNotLoaded) {
      const query = pagination?.cursor ? { cursor: pagination.cursor } : {};
      loadData?.({ query });
      return;
    }

    setTableData?.({
      ...tableData,
      page: activePage,
    });
  },
  getTablePagination: ({
    handleOnPaginate,
    tableData = {},
    perPagePagination = DEFAULT_PAGE_SIZE
  } = {}) => {
    const {
      page = 1,
      pagination,
      loadedPages = 1,
      rows = []
    } = tableData;

    const hasCursorPagination = Boolean(pagination?.cursor);
    const totalRows = hasCursorPagination
      ? loadedPages * perPagePagination + 1
      : rows.length;

    return {
      current: page,
      disabled: rows.length === 0,
      onChange: handleOnPaginate,
      pageSize: perPagePagination,
      showSizeChanger: false,
      total: totalRows
    };
  }
}
